import { selectApiData } from 'util/selector/apiSelector';

import { AxiosInstance } from 'axios';

import { WebLinkDistributionModel } from './dto/WebLinkDistribution.dto';

export class WebLinkDistributionApi {
  constructor(private client: AxiosInstance) {}

  // WebLinkDistributionDto === WebLinkDistributionModel
  get(projectId: number): Promise<WebLinkDistributionModel> {
    return this.client.get(`/api/v1/project/${projectId}/link-distribution`).then(selectApiData);
  }
}
